<div class="step position-relative d-flex flex-md-column align-items-center">
  <div class="step-content text-md-center order-2 order-md-1 gmb-0 gmb-md-8">
    <ng-content></ng-content>
  </div>

  <div class="order-1 order-md-2 gmr-24 gmr-md-0">
    <div class="step-dot"></div>
  </div>
</div>
